import { TrackableEvent } from "@/analytics/TrackableEvents";
import { MiddlewareContext } from ".";
import { useAnalytics } from "@/plugins/analytics";
import { useAppStore } from "@/stores/app";
import { useUserStore } from "@/stores/user";
import { useProducersStore } from "@/stores/producers";

/**
 * Fire page view event to [AnalyticsStrategies] on base producer (IDV) and selected producers
 *
 * @param context `MiddlewareContext`
 * @returns `void`
 */
export function analytics(context: MiddlewareContext) {
  const userStore = useUserStore();
  const appStore = useAppStore();

  useAnalytics().collect(
    TrackableEvent.PageView,
    {
      producer_id: useProducersStore().selected.id[0],
      params: {
        user_id: userStore.data.id,
        app_commit: appStore.commit,
        app_version: appStore.version,
        standalone: window.matchMedia("(display-mode: standalone)").matches,
      },
    },
  );

  return context.next();
}
